import type { AskNobiActivityItem, AskNobiStatusUpdateChunk } from "./types";

/**
 * Applies a streamed stage update to the current activity items.
 *
 * @param items Existing activity history.
 * @param chunk Latest status update from the assistant stream.
 * @returns Activity items with the current matching stage updated, or a new stage occurrence appended.
 */
export function applyActivityStatusUpdate(
  items: AskNobiActivityItem[],
  chunk: AskNobiStatusUpdateChunk,
): AskNobiActivityItem[] {
  const latestItem = items.at(-1);

  if (latestItem?.type === "stage" && latestItem.stage === chunk.stage && latestItem.status === "running") {
    return [
      ...items.slice(0, -1),
      {
        ...latestItem,
        reasoning: chunk.reasoning ?? latestItem.reasoning,
      },
    ];
  }

  return [
    ...items.map((item) =>
      item.type === "stage" && item.status === "running" ? { ...item, status: "done" as const } : item,
    ),
    {
      type: "stage",
      stage: chunk.stage,
      reasoning: chunk.reasoning,
      status: "running",
    },
  ];
}

/** Removes streamed Markdown emphasis markers and collapses whitespace for a user-facing activity label. */
export function formatActivityReasoning(reasoning: string): string {
  return reasoning.replace(/\*+/g, " ").replace(/\s+/g, " ").trim();
}
